import { render, staticRenderFns } from "./Ecadia.vue?vue&type=template&id=99159f68&scoped=true&"
import script from "./Ecadia.vue?vue&type=script&lang=js&"
export * from "./Ecadia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99159f68",
  null
  
)

export default component.exports